// extracted by mini-css-extract-plugin
export default {"statistics":"statistics_statistics__HjbAo"};